import PropTypes from 'prop-types';
import { Component } from 'react';

import styles from 'part11/components/Document/Document.scss';
import { DocumentScrollArea, DocumentViewerArea } from 'part11/components/Document/Document';
import DocumentHeaderNavigation from 'part11/components/Document/DocumentHeaderNavigation/DocumentHeaderNavigation';
import DocumentViewer from 'part11/components/Document/DocumentViewer/DocumentViewer';

class WorkflowDocument extends Component {

    render() {
        const { document, noScroll, noHeader } = this.props;

        if (!document) {
            return null;
        }

        return (
            <div className={styles.document} data-cy="WorkflowDocument">
                <DocumentHeaderNavigation document={document} noHeader={noHeader} />
                <DocumentScrollArea noScroll={noScroll}>
                    <DocumentViewerArea>
                        <DocumentViewer document={document} />
                    </DocumentViewerArea>
                </DocumentScrollArea>
            </div>
        );
    }

}

WorkflowDocument.propTypes = {
    document: PropTypes.object
};

export default WorkflowDocument;
